import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Group, Page, PageText } from '@memorabid/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenericPageService {
  private readonly _api = inject(ApiService);

  getBySlug(
    slug: string,
    idLanguage: number,
    idSeller?: number
  ): Observable<PageText> {
    return this._api.requestCached(
      ApiServiceHolder.genericpage.getBySlug(slug, idLanguage, idSeller)
    );
  }

  getGroups(idSeller?: number): Observable<Group[]> {
    return this._api.requestCached(
      ApiServiceHolder.genericpage.getGroups(idSeller)
    );
  }

  getHeaderPages(idSeller?: number): Observable<Page[]> {
    return this._api.requestCached(
      ApiServiceHolder.genericpage.getHeaderPages(idSeller)
    );
  }

  getFooterPages(idSeller?: number): Observable<Page[]> {
    return this._api.requestCached(
      ApiServiceHolder.genericpage.getFooterPages(idSeller)
    );
  }
}
